// クリエイターのプロフィール文（p）の高さをPCで揃える（紙工視点 / 2022 共通）

let resizeTimer = null;
const adjustProfileHeight = () => {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    const profs = document.querySelectorAll('section.creators .creator p');
    profs.forEach((p) => p.removeAttribute('style'));
    if (!window.matchMedia('(max-width:1039px)').matches) {
      let maxH = 0;
      profs.forEach((p) => { maxH = Math.max(p.offsetHeight, maxH); });
      profs.forEach((p) => { p.style.height = maxH + 'px'; });
    }
  }, 500);
};

window.addEventListener('load', adjustProfileHeight);
window.addEventListener('resize', adjustProfileHeight);
